// Reimbursement Types form helpers (Payroll > Configuration > Pay Input >
// Reimbursements). The list comes from the reimbursement types/ API (see
// pages/PayRoll/Shared/reimbursementApi.js). `used` marks a type already
// used in a claim, which can be made Inactive but not deleted.

export const EMPTY_REIMBURSEMENT_TYPE = {
  name: "",
  helpText: "",
  limitPerClaim: null,
  limitPerMonth: null,
  billWithinDays: 60,
  billNeeded: true,
  payComponentId: "",
  active: true,
};

// Form values are strings; the type uses numbers (null = no limit).
export const toForm = (row) => ({
  name: row.name,
  helpText: row.helpText || "",
  limitPerClaim: row.limitPerClaim == null ? "" : String(row.limitPerClaim),
  limitPerMonth: row.limitPerMonth == null ? "" : String(row.limitPerMonth),
  billWithinDays: row.billWithinDays == null ? "" : String(row.billWithinDays),
  billNeeded: row.billNeeded,
  payComponentId: row.payComponentId ?? "",
  active: row.active,
});

const toAmount = (value) => (String(value).trim() === "" ? null : Number(value));

export const fromForm = (form) => ({
  name: form.name.trim(),
  helpText: form.helpText.trim(),
  limitPerClaim: toAmount(form.limitPerClaim),
  limitPerMonth: toAmount(form.limitPerMonth),
  billWithinDays: Number(form.billWithinDays),
  billNeeded: form.billNeeded,
  payComponentId: form.payComponentId,
  active: form.active,
});

const isBadAmount = (value) => {
  if (String(value).trim() === "") return false;
  const number = Number(value);
  return !Number.isFinite(number) || number <= 0;
};

// Same rules as the server (name 100, help text 255, bill days 1-3650) plus
// limit per claim not above the monthly limit.
export const validateReimbursementType = (form, rows, editingId) => {
  const errors = {};
  const name = form.name.trim();
  if (!name) errors.name = "Name is required.";
  else if (rows.some((row) => row.id !== editingId && row.name.trim().toLowerCase() === name.toLowerCase())) {
    errors.name = "A reimbursement type with this name already exists.";
  }
  if (isBadAmount(form.limitPerClaim)) errors.limitPerClaim = "Enter an amount above 0, or leave blank.";
  if (isBadAmount(form.limitPerMonth)) errors.limitPerMonth = "Enter an amount above 0, or leave blank.";
  if (
    !errors.limitPerClaim && !errors.limitPerMonth &&
    String(form.limitPerClaim).trim() !== "" && String(form.limitPerMonth).trim() !== "" &&
    Number(form.limitPerClaim) > Number(form.limitPerMonth)
  ) {
    errors.limitPerClaim = "Limit per claim cannot be more than the limit per month.";
  }
  const days = Number(form.billWithinDays);
  if (String(form.billWithinDays).trim() === "") errors.billWithinDays = "Enter the number of days.";
  else if (!Number.isInteger(days) || days < 1 || days > 3650) errors.billWithinDays = "Enter whole days between 1 and 3650.";
  if (form.payComponentId === "" || form.payComponentId == null) errors.payComponentId = "Select a payslip line.";
  return errors;
};

// Server field names -> form field names, for errors in meta.detail.
export const API_FIELD_TO_FORM = {
  name: "name",
  help_text: "helpText",
  limit_per_claim: "limitPerClaim",
  limit_per_month: "limitPerMonth",
  bill_within_days: "billWithinDays",
  bill_required: "billNeeded",
  pay_component_id: "payComponentId",
  is_active: "active",
};

export const formatLimit = (value) =>
  value == null ? "—" : Number(value).toLocaleString("en-IN");
